import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/app/global-error.tsx");
